<template>
  <div class="custom-border-outline mt-3">
    <div class="d-flex justify-content-between flex-wrap align-items-center">
      <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
        {{$t('iframe.titles.legal')}}
      </h5>

      <i
        v-if="collapsable"
        class="clickable p-3"
        :class="{'fa fa-chevron-up': !isCollapsed, 'fa fa-chevron-down': isCollapsed}"
        @click="isCollapsed = !isCollapsed"
      >
      </i>
    </div>
    <div v-if="!isCollapsed">
      <form class="evollu-form">
        <div class="row col-12" style="margin-bottom: 0 !important;">
          <!-- Acceptance Text -->
          <div class="row col-md-8">
            <div class="col-12">
              <va-input
                id="acceptanceText"
                type="textarea"
                :min-rows="2"
                v-model="value.acceptance_text"
                :label="$t('iframe.titles.acceptance_text')"
                :placeholder="$t('iframe.titles.acceptance_text')"
                @input="formErrors.clear('acceptance_text')"
              />

              <small v-show="formErrors.has('acceptance_text')" class="help text-danger">
                {{ $t(formErrors.get('acceptance_text')) }}
              </small>
            </div>
          </div>
          <!-- --- --->

          <!-- Acceptance Text Order -->
          <div class="row col-md-4">
            <div class="col-12">
              <va-input
                id="acceptanceTextOrder"
                type="number"
                v-model.number="value.acceptance_text_order"
                :label="$t('iframe.titles.acceptance_text_order')"
                :placeholder="$t('iframe.titles.acceptance_text_order')"
                @input="formErrors.clear('acceptance_text_order')"
              />

              <small v-show="formErrors.has('acceptance_text_order')" class="help text-danger">
                {{ $t(formErrors.get('acceptance_text_order')) }}
              </small>
            </div>
          </div>
          <!-- --- --->
        </div>

        <div class="row col-12" style="margin-bottom: 0 !important;">
          <!-- Marketing Text -->
          <div class="row col-md-8">
            <div class="col-12">
              <va-input
                id="marketing_text"
                type="textarea"
                :min-rows="2"
                v-model="value.marketing_text"
                :label="$t('iframe.titles.marketing_text')"
                :placeholder="$t('iframe.titles.marketing_text')"
                @input="formErrors.clear('marketing_text')"
              />

              <small v-show="formErrors.has('marketing_text')" class="help text-danger">
                {{ $t(formErrors.get('marketing_text')) }}
              </small>
            </div>
          </div>
          <!-- --- --->

          <!-- Marketing Text Order -->
          <div class="row col-md-4">
            <div class="col-12">
              <va-input
                id="marketing_text_order"
                type="number"
                v-model.number="value.marketing_text_order"
                :label="$t('iframe.titles.marketing_text_order')"
                :placeholder="$t('iframe.titles.marketing_text_order')"
                @input="formErrors.clear('marketing_text_order')"
              />

              <small v-show="formErrors.has('marketing_text_order')" class="help text-danger">
                {{ $t(formErrors.get('marketing_text_order')) }}
              </small>
            </div>
          </div>
          <!-- --- --->
        </div>

        <div class="row col-12" style="margin-bottom: 0 !important;">
          <!-- To Partner Text -->
          <div class="row col-md-8">
            <div class="col-12">
              <va-input
                id="toPartnerText"
                type="textarea"
                :min-rows="2"
                v-model="value.to_partner_text"
                :label="$t('iframe.titles.to_partner_text')"
                :placeholder="$t('iframe.titles.to_partner_text')"
                @input="formErrors.clear('to_partner_text')"
              />

              <small v-show="formErrors.has('to_partner_text')" class="help text-danger">
                {{ $t(formErrors.get('to_partner_text')) }}
              </small>
            </div>
          </div>
          <!-- --- --->

          <!-- To Partner Text Order -->
          <div class="row col-md-4">
            <div class="col-12">
              <va-input
                id="toPartnerTextOrder"
                v-model.number="value.to_partner_text_order"
                type="number"
                :label="$t('iframe.titles.to_partner_text_order')"
                :placeholder="$t('iframe.titles.to_partner_text_order')"
                @input="formErrors.clear('to_partner_text_order')"
              />

              <small v-show="formErrors.has('to_partner_text_order')" class="help text-danger">
                {{ $t(formErrors.get('to_partner_text_order')) }}
              </small>
            </div>
          </div>
          <!-- --- --->
        </div>

        <div class="row col-12" style="margin-bottom: 0 !important;">
          <!-- Terms Text -->
          <div class="row col-md-8">
            <div class="col-12">
              <va-input
                id="termsText"
                v-model="value.terms_text"
                :label="$t('iframe.titles.terms_text')"
                :placeholder="$t('iframe.titles.terms_text')"
                @input="formErrors.clear('terms_text')"
              />

              <small v-show="formErrors.has('terms_text')" class="help text-danger">
                {{ $t(formErrors.get('terms_text')) }}
              </small>
            </div>
          </div>
          <!-- --- --->

          <!-- Terms Text Url -->
          <div class="row col-md-4">
            <div class="col-12">
              <va-input
                id="termsUrl"
                v-model="value.terms_url"
                :label="$t('iframe.titles.terms_url')"
                :placeholder="$t('iframe.titles.terms_url')"
                @input="formErrors.clear('terms_url')"
              />

              <small v-show="formErrors.has('terms_url')" class="help text-danger">
                {{ $t(formErrors.get('terms_url')) }}
              </small>
            </div>
          </div>
          <!-- --- --->
        </div>

        <div class="row col-12" style="margin-bottom: 0 !important;">
          <!-- Consent Intro Text -->
          <div class="row col-12">
            <div class="col-12">
              <va-input
                id="consentIntro"
                v-model="value.consent_intro"
                type="textarea"
                :min-rows="3"
                :label="$t('iframe.titles.consent_intro')"
                :placeholder="$t('iframe.titles.consent_intro')"
                @input="formErrors.clear('consent_intro')"
              />

              <small v-show="formErrors.has('consent_intro')" class="help text-danger">
                {{ $t(formErrors.get('consent_intro')) }}
              </small>
            </div>
          </div>
          <!-- --- --->
        </div>

      </form>
    </div>
  </div>
</template>

<script>

const errorsPrefix = 'iframe.flows.errors.'
import Errors from "@/utils/StandardErrors";

export default {
  props: {
    value: {
      type: Object,
      required: false
    },
    collapsable: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    formErrors: {
      type: Object,
      required: false,
      default: () => {
        return new Errors()
      }
    },
  },
  data: function() {
    return {
      isCollapsed: this.collapsable && this.collapsed,
    }
  },
  watch: {
    'value.acceptance_text_order': function (val) {
      if (val === "") {
        this.value.acceptance_text_order = null
      } else {
        if (this.value.marketing_text_order && this.value.marketing_text_order === val) {
          this.formErrors.record({
            "acceptance_text_order": ["order must be different."]
          }, errorsPrefix)
        }
        if(this.value.to_partner_text_order && this.value.to_partner_text_order === val) {
          this.formErrors.record({
            "acceptance_text_order": ["order must be different."]
          }, errorsPrefix)
        }
      }
    },
    'value.marketing_text_order': function (val) {
      if (val === "") {
        this.value.marketing_text_order = null
      } else {
        if (this.value.acceptance_text_order && this.value.acceptance_text_order === val) {
          this.formErrors.record({
            "marketing_text_order": ["order must be different."]
          }, errorsPrefix)
        }
        if(this.value.to_partner_text_order && this.value.to_partner_text_order === val) {
          this.formErrors.record({
            "marketing_text_order": ["order must be different."]
          }, errorsPrefix)
        }
      }
    },
    'value.to_partner_text_order': function (val) {
      if (val === "") {
        this.value.to_partner_text_order = null
      } else {
        if (this.value.marketing_text_order && this.value.marketing_text_order === val) {
          this.formErrors.record({
            "to_partner_text_order": ["order must be different."]
          }, errorsPrefix)
        }
        if(this.value.acceptance_text_order && this.value.acceptance_text_order === val) {
          this.formErrors.record({
            "to_partner_text_order": ["order must be different."]
          }, errorsPrefix)
        }
      }
    }
  }
}
</script>

<style scoped>
.custom-border-outline {
  border: 2px solid rgba(65, 65, 65, 0.1);
  border-radius: 25px;
}
</style>
